module.exports = __webpack_public_path__ + "static/media/ossi.141e9acb.jpg";